export default "fd6bb6e41a191b52.svg"